// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5144e0ce","239":"2ef32a64","453":"91c21e60","455":"2c5cc85e"}[chunkId] + ".chunk.js";
};